/* eslint-disable */
import { useState, useEffect } from 'react';
import { userAPI } from '../services/api';
import { LoadingSpinner, ErrorBox, EmptyState } from '../components/LoadingSpinner';

const inputStyle = {
  padding:'8px 10px', border:'1.5px solid #ddd', borderRadius:'8px',
  fontSize:'13px', color:'#333', background:'#fafafa',
  outline:'none', width:'100%', fontFamily:'inherit', boxSizing:'border-box'
};

function Modal({ show, onClose, title, children, footer, size='560px' }) {
  if (!show) return null;
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:999, padding:'20px' }}>
      <div style={{ background:'white', borderRadius:'16px', width:'100%', maxWidth:size, maxHeight:'90vh', display:'flex', flexDirection:'column', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 24px', borderBottom:'1px solid #f0f4f8' }}>
          <h3 style={{ fontSize:'15px', color:'#1a3a5c', margin:0 }}>{title}</h3>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:'20px', cursor:'pointer', color:'#888' }}>✕</button>
        </div>
        <div style={{ padding:'20px', overflowY:'auto', flex:1, display:'flex', flexDirection:'column', gap:'14px' }}>{children}</div>
        {footer && <div style={{ padding:'14px 20px', borderTop:'1px solid #f0f4f8', display:'flex', justifyContent:'flex-end', gap:'10px' }}>{footer}</div>}
      </div>
    </div>
  );
}

function Btn({ onClick, color='biru', children, disabled, size='normal' }) {
  const colors = {
    biru:  { bg:'linear-gradient(135deg,#1a3a5c,#2d6a9f)', txt:'white' },
    hijau: { bg:'linear-gradient(135deg,#1e8449,#27ae60)',  txt:'white' },
    merah: { bg:'linear-gradient(135deg,#c0392b,#e74c3c)',  txt:'white' },
    orange:{ bg:'linear-gradient(135deg,#ca6f1e,#e67e22)',  txt:'white' },
    abu:   { bg:'white', txt:'#333', border:'1.5px solid #ddd' },
  };
  const c = colors[color];
  const pad = size==='small' ? '5px 10px' : '9px 16px';
  return (
    <button onClick={onClick} disabled={disabled} style={{ padding:pad, background:c.bg, color:c.txt, border:c.border||'none', borderRadius:'8px', fontSize: size==='small'?'11px':'13px', fontWeight:'600', cursor:disabled?'not-allowed':'pointer', opacity:disabled?0.6:1, whiteSpace:'nowrap' }}>
      {children}
    </button>
  );
}

function FG({ label, required, children, span }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'6px', gridColumn: span?'1/-1':'auto' }}>
      <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>{label} {required && <span style={{ color:'#e74c3c' }}>*</span>}</label>
      {children}
    </div>
  );
}

const divisiOptions = [
  { val:'direktur', label:'Direktur / Admin' },
  { val:'proyek',   label:'Manajer Proyek'   },
  { val:'logistik', label:'Logistik & Pengadaan' },
  { val:'hse',      label:'HSE / K3'          },
  { val:'keuangan', label:'Keuangan'          },
];

const tabKeuanganOptions = [
  { kode:'ringkasan',    label:'📊 Ringkasan' },
  { kode:'kasbank',      label:'🏦 Kas & Bank' },
  { kode:'pengajuankas', label:'📝 Pengajuan Kas' },
  { kode:'laporankas',   label:'📄 Laporan Penggunaan Kas' },
  { kode:'pengeluaran',  label:'📋 Laporan Pengeluaran' },
  { kode:'invoice',      label:'📄 Invoice / Faktur' },
  { kode:'anggaran',     label:'📋 Anggaran & Budget' },
  { kode:'vendor',       label:'🏢 Pembayaran Vendor' },
];

function badgeDivisi(divisi) {
  const map = {
    direktur:{bg:'#f3e5f5',color:'#8e44ad',label:'👑 Direktur'},
    proyek:{bg:'#eaf0fb',color:'#2980b9',label:'📁 Proyek'},
    logistik:{bg:'#fef5e7',color:'#e67e22',label:'🛒 Logistik'},
    hse:{bg:'#fdedec',color:'#e74c3c',label:'⛑️ HSE'},
    keuangan:{bg:'#eafaf1',color:'#27ae60',label:'💰 Keuangan'},
  };
  const m = map[divisi] || {bg:'#f0f4f8',color:'#666',label:divisi};
  return <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:m.bg, color:m.color, whiteSpace:'nowrap' }}>{m.label}</span>;
}

function ManajemenUser({ user }) {
  const [list, setList]           = useState([]);
  const [modules, setModules]     = useState([]);
  const [loading, setLoading]     = useState(true);
  const [showForm, setShowForm]   = useState(false);
  const [showAkses, setShowAkses] = useState(null);
  const [showResetPw, setShowResetPw] = useState(null);
  const [aksesUser, setAksesUser] = useState([]);
  const [tabKeuangan, setTabKeuangan] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [editUser, setEditUser]   = useState(null);
  const [confirmHapus, setConfirmHapus] = useState(null);

  const [form, setForm] = useState({ username:'', password:'', nama:'', divisi:'', role:'', akses:[] });
  const [newPassword, setNewPassword] = useState('');

  // Guard akses halaman
  if (user?.divisi !== 'direktur') {
    return (
      <div style={{ padding:'60px', textAlign:'center' }}>
        <div style={{ fontSize:'48px', marginBottom:'16px' }}>🔒</div>
        <h3 style={{ color:'#1a3a5c' }}>Akses Terbatas</h3>
        <p style={{ color:'#888' }}>Hanya Direktur/Administrator yang dapat mengelola user.</p>
      </div>
    );
  }

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    setLoading(true);
    try {
      const [uRes, mRes] = await Promise.all([userAPI.getAll(), userAPI.getAllModules()]);
      if (uRes.ok) setList(uRes.data.data);
      if (mRes.ok) setModules(mRes.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form, [e.target.name]: e.target.value}); }
  function toggleModulForm(kode) {
    setForm({ ...form, akses: form.akses.includes(kode) ? form.akses.filter(k=>k!==kode) : [...form.akses, kode] });
  }

  function bukaTambah() {
    setEditUser(null);
    setForm({ username:'', password:'', nama:'', divisi:'', role:'', akses:['dashboard'] });
    setShowForm(true);
  }

  function bukaEdit(u) {
    setEditUser(u);
    setForm({ username:u.username, password:'', nama:u.nama, divisi:u.divisi, role:u.role||'', akses:[] });
    setShowForm(true);
  }

  async function submitForm() {
    if (!form.nama || !form.divisi) { alert('⚠️ Nama dan divisi wajib diisi!'); return; }
    if (!editUser && (!form.username || !form.password)) { alert('⚠️ Username dan password wajib diisi!'); return; }
    setSubmitting(true);
    try {
      let result;
      if (editUser) {
        result = await userAPI.update(editUser.id, { nama: form.nama, divisi: form.divisi, role: form.role, is_active: editUser.is_active });
      } else {
        result = await userAPI.create(form);
      }
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function bukaAturAkses(u) {
    setShowAkses(u);
    try {
      const result = await userAPI.getById(u.id);
      if (result.ok) setAksesUser(result.data.data.akses || []);
      const tabRes = await userAPI.getTabKeuangan(u.id);
      if (tabRes.ok) setTabKeuangan(tabRes.data.data || []);
    } catch(err) {}
  }

  function toggleTabKeuangan(kode) {
    setTabKeuangan(tabKeuangan.includes(kode) ? tabKeuangan.filter(k=>k!==kode) : [...tabKeuangan, kode]);
  }

  function toggleModulAkses(kode) {
    setAksesUser(aksesUser.includes(kode) ? aksesUser.filter(k=>k!==kode) : [...aksesUser, kode]);
  }

  async function simpanAkses() {
  setSubmitting(true);
  try {
    const result = await userAPI.updateAkses(showAkses.id, aksesUser);
    if (!result.ok) { alert(`❌ ${result.data.message}`); setSubmitting(false); return; }

    if (aksesUser.includes('keuangan')) {
      const tabResult = await userAPI.updateTabKeuangan(showAkses.id, tabKeuangan);
      if (!tabResult.ok) { alert(`❌ ${tabResult.data.message}`); setSubmitting(false); return; }
    }

    alert('✅ Akses modul berhasil diperbarui!');
    setShowAkses(null);
    fetchData();
  } catch(err) { alert('❌ Gagal terhubung ke server'); }
  finally { setSubmitting(false); }
  }

  async function submitResetPassword() {
    if (!newPassword || newPassword.length < 6) { alert('⚠️ Password minimal 6 karakter!'); return; }
    setSubmitting(true);
    try {
      const result = await userAPI.resetPassword(showResetPw.id, newPassword);
      if (result.ok) {
        alert('✅ Password berhasil direset!');
        setShowResetPw(null);
        setNewPassword('');
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function toggleStatus(u) {
    if (!window.confirm(`${u.is_active?'Nonaktifkan':'Aktifkan'} user ${u.nama}?`)) return;
    try {
      const result = u.is_active ? await userAPI.nonaktifkan(u.id) : await userAPI.aktifkan(u.id);
      if (result.ok) { alert(`✅ ${result.data.message}`); fetchData(); }
      else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
  }

  async function konfirmasiHapus() {
    setSubmitting(true);
    try {
      const result = await userAPI.hapus(confirmHapus.id);
      if (result.ok) { alert(`✅ ${result.data.message}`); setConfirmHapus(null); fetchData(); }
      else { alert(`❌ ${result.data.message}`); setConfirmHapus(null); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  // Group modules by kategori
  const byKategori = {};
  modules.forEach(m => { if(!byKategori[m.kategori]) byKategori[m.kategori]=[]; byKategori[m.kategori].push(m); });

  if (loading) return <LoadingSpinner pesan="Memuat data user..." />;

  const totalAktif   = list.filter(u=>u.is_active).length;
  const totalNonaktif= list.filter(u=>!u.is_active).length;
  const totalAdmin   = list.filter(u=>u.divisi==='direktur').length;

  return (
    <div style={{ display:'flex', flexDirection:'column' }}>
      <header style={{ display:'flex', justifyContent:'space-between', alignItems:'center', background:'white', padding:'14px 24px', borderBottom:'1px solid #e8edf2', position:'sticky', top:0, zIndex:10 }}>
        <div>
          <h1 style={{ fontSize:'18px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>Manajemen User</h1>
          <span style={{ fontSize:'12px', color:'#888' }}>Kelola akun dan akses modul pengguna sistem</span>
        </div>
        <div style={{ fontSize:'13px', color:'#666' }}>👤 {user?.nama} — {user?.role}</div>
      </header>

      <div style={{ padding:'24px', display:'flex', flexDirection:'column', gap:'20px' }}>

        {/* STAT */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'16px' }}>
          {[
            { icon:'👥', label:'Total User',    val: list.length,    bg:'linear-gradient(135deg,#1a3a5c,#2d6a9f)' },
            { icon:'🟢', label:'User Aktif',    val: totalAktif,     bg:'linear-gradient(135deg,#1e8449,#27ae60)'  },
            { icon:'⚫', label:'Nonaktif',      val: totalNonaktif,  bg:'linear-gradient(135deg,#616a6b,#839192)'  },
            { icon:'👑', label:'Administrator', val: totalAdmin,     bg:'linear-gradient(135deg,#6c3483,#8e44ad)'  },
          ].map((s,i)=>(
            <div key={i} style={{ background:s.bg, borderRadius:'12px', padding:'20px', color:'white', display:'flex', flexDirection:'column', gap:'6px' }}>
              <span style={{ fontSize:'20px' }}>{s.icon}</span>
              <span style={{ fontSize:'24px', fontWeight:'700' }}>{s.val}</span>
              <span style={{ fontSize:'12px', opacity:0.85 }}>{s.label}</span>
            </div>
          ))}
        </div>

        {/* TOOLBAR */}
        <div style={{ display:'flex', justifyContent:'flex-end' }}>
          <Btn onClick={bukaTambah}>+ Tambah User Baru</Btn>
        </div>

        {/* TABEL USER */}
        {list.length === 0 ? (
          <EmptyState icon="👥" judul="Belum ada user" sub="Klik '+ Tambah User Baru' untuk membuat akun" />
        ) : (
          <div style={{ background:'white', borderRadius:'12px', overflow:'hidden', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                  {['Username','Nama','Divisi','Role/Jabatan','Akses Modul','Status','Terakhir Login','Aksi'].map(h=>(
                    <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {list.map(u=>(
                  <tr key={u.id} style={{ borderBottom:'1px solid #f5f7fa', opacity: u.is_active?1:0.5 }}>
                    <td style={{ padding:'12px', fontSize:'13px' }}><strong>{u.username}</strong></td>
                    <td style={{ padding:'12px', fontSize:'13px' }}>{u.nama}</td>
                    <td style={{ padding:'12px' }}>{badgeDivisi(u.divisi)}</td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{u.role||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>
                      <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:'#eaf0fb', color:'#2d6a9f' }}>
                        {u.total_akses} modul
                      </span>
                    </td>
                    <td style={{ padding:'12px' }}>
                      <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background: u.is_active?'#eafaf1':'#f0f4f8', color: u.is_active?'#27ae60':'#888' }}>
                        {u.is_active?'🟢 Aktif':'⚫ Nonaktif'}
                      </span>
                    </td>
                    <td style={{ padding:'12px', fontSize:'11px', color:'#888' }}>
                      {u.last_login ? new Date(u.last_login).toLocaleString('id-ID',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}) : 'Belum pernah'}
                    </td>
                    <td style={{ padding:'12px' }}>
                      <div style={{ display:'flex', gap:'6px', flexWrap:'wrap' }}>
                        <Btn size="small" color="abu" onClick={()=>bukaEdit(u)}>✏️ Edit</Btn>
                        <Btn size="small" color="biru" onClick={()=>bukaAturAkses(u)}>🔑 Akses</Btn>
                        <Btn size="small" color="orange" onClick={()=>{ setShowResetPw(u); setNewPassword(''); }}>🔒 Reset PW</Btn>
                        {u.id !== user?.id && (
                          <>
                            <Btn size="small" color={u.is_active?'abu':'hijau'} onClick={()=>toggleStatus(u)}>
                              {u.is_active ? '⏸️ Nonaktifkan' : '▶️ Aktifkan'}
                            </Btn>
                            <Btn size="small" color="merah" onClick={()=>setConfirmHapus(u)}>🗑️ Hapus</Btn>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* MODAL TAMBAH/EDIT USER */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title={editUser ? `✏️ Edit User — ${editUser.username}` : '➕ Tambah User Baru'}
        footer={<>
          <Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn>
          <Btn onClick={submitForm} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn>
        </>}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <FG label="Username" required>
            <input name="username" value={form.username} onChange={handleChange} disabled={!!editUser}
              placeholder="username" style={{ ...inputStyle, background: editUser?'#f0f4f8':'#fafafa' }} />
          </FG>
          {!editUser && (
            <FG label="Password" required>
              <input type="password" name="password" value={form.password} onChange={handleChange} placeholder="Minimal 6 karakter" style={inputStyle} />
            </FG>
          )}
          <FG label="Nama Lengkap" required span={!!editUser}>
            <input name="nama" value={form.nama} onChange={handleChange} placeholder="Nama lengkap" style={inputStyle} />
          </FG>
          <FG label="Divisi" required>
            <select name="divisi" value={form.divisi} onChange={handleChange} style={inputStyle}>
              <option value="">-- Pilih Divisi --</option>
              {divisiOptions.map(d=><option key={d.val} value={d.val}>{d.label}</option>)}
            </select>
          </FG>
          <FG label="Role / Jabatan">
            <input name="role" value={form.role} onChange={handleChange} placeholder="Contoh: Staff Logistik" style={inputStyle} />
          </FG>
        </div>

        {!editUser && (
          <div>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555', display:'block', marginBottom:'8px' }}>Akses Modul Awal</label>
            <div style={{ display:'flex', flexDirection:'column', gap:'10px', maxHeight:'220px', overflowY:'auto', border:'1px solid #eee', borderRadius:'8px', padding:'12px' }}>
              {Object.entries(byKategori).map(([kategori, mods])=>(
                <div key={kategori}>
                  <div style={{ fontSize:'11px', fontWeight:'700', color:'#888', marginBottom:'6px', textTransform:'uppercase' }}>{kategori}</div>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:'8px' }}>
                    {mods.map(m=>(
                      <label key={m.kode} style={{ display:'flex', alignItems:'center', gap:'6px', padding:'6px 10px', background: form.akses.includes(m.kode)?'#eaf0fb':'#f8f9fa', border: form.akses.includes(m.kode)?'1.5px solid #2d6a9f':'1.5px solid #eee', borderRadius:'8px', cursor:'pointer', fontSize:'12px' }}>
                        <input type="checkbox" checked={form.akses.includes(m.kode)} onChange={()=>toggleModulForm(m.kode)} />
                        {m.icon} {m.nama}
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal>

      {/* MODAL ATUR AKSES */}
      <Modal show={!!showAkses} onClose={()=>setShowAkses(null)} title={`🔑 Atur Akses Modul — ${showAkses?.nama}`}
        footer={<>
          <Btn color="abu" onClick={()=>setShowAkses(null)} disabled={submitting}>Batal</Btn>
          <Btn onClick={simpanAkses} disabled={submitting}>{submitting?'⏳...':'✅ Simpan Akses'}</Btn>
        </>}>
        {showAkses && (
          <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ fontSize:'12px', color:'#888' }}>{aksesUser.length} dari {modules.length} modul dipilih</span>
              <div style={{ display:'flex', gap:'8px' }}>
                <button onClick={()=>setAksesUser(modules.map(m=>m.kode))} style={{ fontSize:'11px', background:'none', border:'none', color:'#2d6a9f', cursor:'pointer', textDecoration:'underline' }}>Pilih Semua</button>
                <button onClick={()=>setAksesUser([])} style={{ fontSize:'11px', background:'none', border:'none', color:'#e74c3c', cursor:'pointer', textDecoration:'underline' }}>Kosongkan</button>
              </div>
            </div>
            {Object.entries(byKategori).map(([kategori, mods])=>(
              <div key={kategori}>
                <div style={{ fontSize:'12px', fontWeight:'700', color:'#1a3a5c', marginBottom:'8px', paddingBottom:'4px', borderBottom:'1px solid #f0f4f8' }}>{kategori}</div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
                  {mods.map(m=>(
                    <label key={m.kode} style={{ display:'flex', alignItems:'center', gap:'8px', padding:'8px 12px', background: aksesUser.includes(m.kode)?'#eaf0fb':'#f8f9fa', border: aksesUser.includes(m.kode)?'1.5px solid #2d6a9f':'1.5px solid #eee', borderRadius:'8px', cursor:'pointer', fontSize:'13px' }}>
                      <input type="checkbox" checked={aksesUser.includes(m.kode)} onChange={()=>toggleModulAkses(m.kode)} />
                      {m.icon} {m.nama}
                    </label>
                  ))}
                </div>
              </div>
            ))}
            {aksesUser.includes('keuangan') && (
              <div style={{ background:'#f8fbff', border:'1.5px solid #e0e8f4', borderRadius:'10px', padding:'14px' }}>
                <div style={{ fontSize:'12px', fontWeight:'700', color:'#1a3a5c', marginBottom:'10px' }}>
                  💰 Tab yang boleh diakses di modul Keuangan
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
                  {tabKeuanganOptions.map(t=>(
                    <label key={t.kode} style={{ display:'flex', alignItems:'center', gap:'8px', padding:'8px 12px', background: tabKeuangan.includes(t.kode)?'#eafaf1':'white', border: tabKeuangan.includes(t.kode)?'1.5px solid #27ae60':'1.5px solid #eee', borderRadius:'8px', cursor:'pointer', fontSize:'12px' }}>
                      <input type="checkbox" checked={tabKeuangan.includes(t.kode)} onChange={()=>toggleTabKeuangan(t.kode)} />
                      {t.label}
                    </label>
                  ))}
                </div>
                <p style={{ fontSize:'11px', color:'#888', margin:'10px 0 0' }}>
                  Jika tidak ada tab dicentang, user hanya bisa melihat tab Ringkasan (default).
                </p>
              </div>
            )}
          </div>
        )}
      </Modal>

      {/* MODAL RESET PASSWORD */}
      <Modal show={!!showResetPw} onClose={()=>setShowResetPw(null)} title={`🔒 Reset Password — ${showResetPw?.username}`} size="420px"
        footer={<>
          <Btn color="abu" onClick={()=>setShowResetPw(null)} disabled={submitting}>Batal</Btn>
          <Btn color="orange" onClick={submitResetPassword} disabled={submitting}>{submitting?'⏳...':'🔒 Reset Password'}</Btn>
        </>}>
        <FG label="Password Baru" required>
          <input type="password" value={newPassword} onChange={e=>setNewPassword(e.target.value)} placeholder="Minimal 6 karakter" style={inputStyle} />
        </FG>
        <p style={{ fontSize:'11px', color:'#888', margin:0 }}>⚠️ User akan menggunakan password baru ini untuk login berikutnya.</p>
      </Modal>

      {/* MODAL KONFIRMASI HAPUS */}
      <Modal show={!!confirmHapus} onClose={()=>setConfirmHapus(null)} title="⚠️ Konfirmasi Hapus User" size="420px"
        footer={<>
          <Btn color="abu" onClick={()=>setConfirmHapus(null)} disabled={submitting}>Batal</Btn>
          <Btn color="merah" onClick={konfirmasiHapus} disabled={submitting}>{submitting?'⏳...':'🗑️ Ya, Hapus Permanen'}</Btn>
        </>}>
        <p style={{ fontSize:'13px', color:'#333' }}>
          Yakin ingin menghapus user <strong>{confirmHapus?.nama}</strong> ({confirmHapus?.username}) secara permanen?
        </p>
        <div style={{ background:'#fef5e7', padding:'12px', borderRadius:'8px', fontSize:'12px', color:'#8a5a00' }}>
          ⚠️ Jika user memiliki riwayat transaksi (PO, laporan, dll), penghapusan akan gagal dan Anda perlu menggunakan tombol <strong>Nonaktifkan</strong> sebagai gantinya.
        </div>
      </Modal>
    </div>
  );
}

export default ManajemenUser;